export const setNestingLvl = (nav, i) => {
    let index = i;
    nav.lvl = index;

    if (nav?.children?.length > 0) {
        index++;
        nav.children.map(child => setNestingLvl(child, index));
    }
};
